// src/pages/Login.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Paper } from '@mui/material';
import axios from 'axios';

export default function Login() {
  const [username, setUsername] = useState('');  // use "username" now
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const API = process.env.REACT_APP_API_URL;
      const res = await axios.post(
        `${API}/login/`,
        { username, password },
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,      // ← include session cookie
        }
      );
      if (res.data.success) {
        // Mark ourselves as logged in
        localStorage.setItem('auth', 'true');
        navigate('/dashboard', { replace: true });
      } else {
        alert('Invalid credentials');
      }
    } catch (err) {
      alert('Login failed');
      console.error(err);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Paper elevation={3} sx={{ p: 4, width: 300 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Sign In
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            label="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            fullWidth
            margin="normal"
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
          >
            Sign In
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
